import { getCurrentURL, listener, ListenerTypes } from "../shared";

interface UrlChangeStorage {
  observer: MutationObserver | null;
  previousHref: string;
}

export interface UrlChangeHandlerMetaData {
  currentUrl: string;
  previousUrl: string;
}

export const UrlChange = (() => {
  const storage: UrlChangeStorage = {
    observer: null,
    previousHref: "",
  };

  const onUrlChangeHandler = (
    urlChangeHandlerMetaData: UrlChangeHandlerMetaData
  ) => {
    listener.emit(ListenerTypes.urlChange, urlChangeHandlerMetaData);
  };

  listener.on(ListenerTypes.visibilityChange, (isPageHidden: boolean) => {
    if (isPageHidden) {
      if (storage.observer) {
        storage.observer.disconnect();
        storage.observer = null;
      }
    }
  });

  const setListener = () => {
    const observer = new MutationObserver(function (mutations) {
      const currentUrl = getCurrentURL();

      const previousUrl = storage.previousHref;

      if (currentUrl !== previousUrl) {
        /**
         * Only call callback if the previous location is defined,
         * this is to prevent the callback from being called on page load
         */
        if (previousUrl) {
          onUrlChangeHandler({
            currentUrl,
            previousUrl,
          });
        }

        storage.previousHref = currentUrl;
      }
    });

    const config = { subtree: true, childList: true, attributes: true };
    observer.observe(document, config);

    storage.observer = observer;

    listener.set(ListenerTypes.urlChange);
  };

  return {
    start: () => {
      setListener();
    },
  };
})();
